import { Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../common/constants/Routes';
import theme from '../../../common/theme';
import '../dashboard.scss';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { useDispatch } from 'react-redux';

import TableComponent from '../../../common/ui/TableComponent';

// import { Spin } from 'antd';

import { useTranslation } from 'react-i18next';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomButton from '../../../common/ui/CustomButton';
import TravelRequisionHeader from './TravelRequisionHeader';

function TravelRequisitionTable() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [tableRow, setTableRow] = useState([]);
	const [open, setOpen] = useState(false);
	const [Succesopen, setSuccesopen] = useState(false);
	const [id, setId] = useState('');
	const success = () => {
		setSuccesopen(true);
	};
	useEffect(() => {
		const paylod = {
			pageNo: 1,
		};

		// dispatch( getTeamMemberRolesListInProgress(paylod))
	}, []);

	// console.log("teamMember",teamMemberData)
	// console.log("id",id)
	const [currentPage, setCurrentPage] = useState(0);
	const [pageSize, setPageSize] = useState(10);

	const handlePaginationChange = (paginationModel: any) => {
		const { page, pageSize } = paginationModel;

		setCurrentPage(page);
		setPageSize(pageSize);
	};

	const handleDelete = () => {
		setOpen(true);
	};
	const handleDeleteAndSetId = (id: any) => {
		handleDelete();
		setId(id);
	};
	const columns: any = [
		{
			headerName: 'Req.no',
			field: 'reqNo',
			width: 100,
		},
		{
			headerName: 'Tour Type',
			field: 'tourType',
			width: 150,
		},
		{
			headerName: 'Requested Date',
			field: 'requestedDate',
			width: 150,
		},
		{
			headerName: 'Tour From Date',
			field: 'tourFromDate',
			width: 150,
		},

		{
			headerName: 'Tour to Date',
			field: 'tourToDate',
			width: 150,
		},
		{
			headerName: 'RM Status',
			field: 'rmStatus',
			width: 100,
		},
		{
			headerName: 'HOD Status',
			field: 'hodStatus',
			width: 200,
		},
		{
			headerName: 'Regional Admin',
			field: 'regionalAdmin',
			width: 200,
		},
		{
			headerName: 'Financial Status',
			field: 'financialStatus',
			width: 200,
		},
		{
			headerName: 'Name',
			field: 'name',
			width: 250,
		},
	];
	const rows: any = [
		{
			id: 1,
			reqNo: 'REQ001',

			tourType: 'Type A',
			requestedDate: '2023-12-10',
			tourFromDate: '2023-12-15',
			tourToDate: '2023-12-20',
			rmStatus: 'Approved',
			name: 'Arun Kumar(TM001)',
			hodStatus: 'Approved',
			regionalAdmin: 'Pending at Regional Admin',
			financialStatus: 'pending',
		},
		{
			id: 2,
			reqNo: 'REQ002',
			name: 'Surya(TM002)',
			tourType: 'Type B',
			requestedDate: '2023-11-05',
			tourFromDate: '2023-11-10',
			tourToDate: '2023-11-15',
			rmStatus: 'Pending',
			hodStatus: 'Approved',
			regionalAdmin: 'Pending at Regional Admin',
			financialStatus: 'pending',
		},
		{
			id: 3,
			reqNo: 'REQ003',
			name: 'Keerthi(TM003)',
			tourType: 'Type C',
			requestedDate: '2023-10-20',
			tourFromDate: '2023-10-25',
			tourToDate: '2023-11-05',
			rmStatus: 'Rejected',
			hodStatus: 'Approved',
			regionalAdmin: 'Pending at Regional Admin',
			financialStatus: 'pending',
		},
	];

	// Pass this 'rows' array as a prop to your TableComponent

	return (
		<Grid container>
			<Grid xs={12} mb={5}>
				<TravelRequisionHeader />
			</Grid>{' '}
			<Grid
				item
				container
				display="flex"
				alignItems={'center'}
				mb={2}
				justifyContent={'space-around'}
				// className='login-form'
				spacing={1}
			>
				<Grid item xs={6} sm={4} md={3} lg={2} xl={2} mb={3}>
					<Typography className="from-date-text">Req.No:</Typography>
					<TextField
						label={'Req.no'}
						size="small"
						variant="outlined"
						//   value={searchQuery}
						//   onChange={handleSearchChange}
						fullWidth
					/>
				</Grid>
				<Grid item xs={6} sm={4} md={3} lg={2} xl={2} mb={3}>
					<Typography className="from-date-text">Applied Date:</Typography>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker slotProps={{ textField: { size: 'small' } }} />
					</LocalizationProvider>
				</Grid>

				<Grid item xs={6} sm={4} md={3} lg={2} xl={2} mb={3}>
					<Typography className="from-date-text">From Date:</Typography>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker slotProps={{ textField: { size: 'small' } }} />
					</LocalizationProvider>
				</Grid>
				<Grid item xs={6} sm={4} md={3} lg={2} xl={2} mb={3}>
					<Typography className="from-date-text">To Date:</Typography>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker slotProps={{ textField: { size: 'small' } }} />
					</LocalizationProvider>
				</Grid>
				<Grid
					item
					xs={10}
					sm={7}
					md={12}
					lg={3}
					xl={3}
					display={'flex'}
					spacing={2}
					container
				>
					<Grid item>
						<CustomButton
							type="button"
							text={t('SEARCH')}
							className="px-5 py-3 primary-button"
						/>
					</Grid>{' '}
					<Grid item>
						<CustomButton
							type="button"
							text={t('EXPORT_TO_EXCEL')}
							className="px-5 py-3 primary-button"
						/>
					</Grid>
				</Grid>
			</Grid>
			<Grid xs={12}>
				<TableComponent
					rows={rows}
					columns={columns}
					totalRecords={rows.length}
					paginationModel={{ page: currentPage, pageSize: pageSize }}
					handlePagination={handlePaginationChange}
				/>
			</Grid>
		</Grid>
	);
}
export default TravelRequisitionTable;
